import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GridDataResult } from "@progress/kendo-angular-grid";
import { BehaviorSubject } from "rxjs-compat";
import { AppConstant } from "src/app/app.constant";

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import { DataSourceRequestState, DataResult } from '@progress/kendo-data-query';


@Injectable()
export class ComplaintService {
    apiUrl: string;
    kendoDataUrl: string;
    constructor(
        private httpClient: HttpClient,
        private appConstant: AppConstant) {
        this.apiUrl = this.appConstant.getUrl()
    }
    manageComplaint(complaint) {
        return this.httpClient.post(`${this.apiUrl}/manageComplaint`, complaint).pipe(
          map((response: any) => {
            return response;
          })
        )
      }
    getComplaintTpoComplaintAgainstList(complaintTo: number, complaintAgainst: number, branchId: number) {
        return this.httpClient.get(`${this.apiUrl}/complaintToComplaintAgainstList/` + complaintTo + '/app/' + complaintAgainst + '/app/' + branchId).pipe(
            map((response: any) => {

                let data = response
                return {
                    complainToList: data.complainToList,
                    complainAgainstList: data.complainAgainstList,
                    userRoles: data.userRoles,
                }
            })
        ) as any as Observable<any>;
    }
    getComplaintByBranchId(branchId: number, state: DataSourceRequestState): Observable<DataResult> {
        let params = {
            branchId: branchId,
            state: state
        }
        return this.httpClient.post(`${this.apiUrl}/complaintList/`, params).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    getAllComplaint(state): Observable<DataResult> {
        let params ={
            state : state
        }
        return this.httpClient.post(`${this.apiUrl}/getAllComplaint`,params).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    getAllComplaintByUser(): Observable<DataResult> {
        return this.httpClient.get(`${this.apiUrl}/getAllComplaintByUser/`).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    getAllComplaintKendo() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/getAllComplaint/`).map(res => res)
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }

    getComplaintByComplaintTo(userId: number, state: DataSourceRequestState): Observable<DataResult> {
        let params = {
            userId: userId,
            state: state
        }
        return this.httpClient.post(`${this.apiUrl}/complaintListByComplaintTo/`, params).pipe(
            map((response: any) => {
                return {
                    data: response.data,
                    total: response.total
                } as GridDataResult
            })
        ) as any as Observable<GridDataResult>
    }
    getComplaintByBranchIdExcel(branchId: number) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/complaintListExcel/` + branchId).map(res => res)
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
    getComplaintByComplaintToExcel(userId: number) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(`${this.apiUrl}/complaintListByComplaintToExcel/` + userId).map(res => res)
                .subscribe(res => {
                    resolve(res);
                }, (err) => {
                    reject(err);
                });
        });
    }
}